import React, {
    useCallback,
    useContext,
    useMemo
} from 'react';
import { useHistory } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import { CepConstants } from 'saga-cep-specific-components';
import { useSgTrackPageName, SgDateUtil } from 'saga-modules';
import { WizardPage } from 'gw-portals-wizard-react';
import SgCepSideMenu from 'sg-cep-side-menu';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';
import SgPolicySummaryInfo from 'sg-policy-summary-info';
import SgOtherProducts from 'sg-other-products';
import SgMultiCarousel from 'sg-multi-carousel';
import CommonConstants from 'sg-common-constants';
import metadata from './SgRenewalConfirmationPage.metadata.json5';
import messages from './SgRenewalConfirmationPage.messages';

function SgRenewalConfirmationPage(props) {
    const {
        wizardData: modelVM
    } = props;
    const translator = useContext(TranslatorContext);
    const history = useHistory();
    useSgTrackPageName(CepConstants.PAGE_NAMES.RENEWAL_CONFIRMATION);
    const productCode = modelVM.baseData.productCode.value;
    const paymentPlanName = modelVM.paymentPlan.value;

    const isMonthly = useMemo(() => {
        return paymentPlanName === CommonConstants.PAYMENT_PLANS.MONTHLY
            || paymentPlanName === CommonConstants.PAYMENT_PLANS.MONTHLY_UPFRONT;
    }, [paymentPlanName]);

    const backToMainPage = useCallback(() => {
        history.push('/home');
    }, [history]);

    const carouselContent = useMemo(() => {
        return (
            <>
                <SgMultiCarousel
                    carouselSet={SgCepLobSpecificUtil.getCarouselArticles(true, productCode)}
                    product={SgCepLobSpecificUtil.getProductName(productCode)}
                />
            </>
        );
    }, [productCode]);

    const overrideProps = {
        confirmationHeader: {
            content: translator(messages.ConfirmationHeader, {
                policyHolder: modelVM.baseData.accountName.value,
                product: SgCepLobSpecificUtil.getProductName(productCode)
            })
        },
        policySummaryInfo: {
            isRenewal: true,
            productInfo: translator(SgCepLobSpecificUtil.getProductSummaryInfoMessage(productCode),
                SgCepLobSpecificUtil.getProductSummaryInfoParameters(productCode, modelVM, translator)),
            policyNumber: modelVM.policyNumber.value,
            coverType: translator(SgCepLobSpecificUtil.getCoverTypeMessage(productCode)),
            coverLevel: SgCepLobSpecificUtil.getCoverLevel(productCode, modelVM),
            periodStartDate: modelVM.baseData.periodStartDate.value,
            periodEndDate: SgDateUtil.addDaysToDateDTO(-1, modelVM.baseData.periodEndDate.value),
            paymentPlanName: modelVM.paymentPlan.value,
            showPaymentMethod: SgCepLobSpecificUtil.shouldShowConfirmationPaymentMethod(productCode, modelVM),
            totalCost: modelVM.totalCost.value,
            nextInstallment: modelVM.renewalDetails.installmentsInfo_Ext.value
                ? modelVM.renewalDetails.installmentsInfo_Ext.firstInstallmentAmount.value : '',
            remainingInstallments: modelVM.renewalDetails.installmentsInfo_Ext.value
                ? modelVM.renewalDetails.installmentsInfo_Ext.installmentAmount.value : ''
        },
        carouselElement: {
            content: carouselContent
        },
        otherProductsInfo: {
            hideProducts: SgCepLobSpecificUtil.getProductsToHideInSagaOtherProducts(productCode)
        },
        abilityToPayInfo: {
            visible: SgCepLobSpecificUtil.showAbilityToPayInfo(productCode) && isMonthly
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            backToMainPage
        },
        resolveComponentMap: {
            SgPolicySummaryInfo,
            SgOtherProducts,
            SgMultiCarousel,
            SgCepSideMenu
        }
    };

    return (
        <WizardPage showPrevious={false} showNext={false}>
            {renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)}
        </WizardPage>
    );
}

export default SgRenewalConfirmationPage;
